module.exports = __webpack_public_path__ + "img/moiseenko.78206354.jpg";